import { render } from "./AccessWallet.vue?vue&type=template&id=5f39dea6"
import script from "./AccessWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessWallet.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/AccessWallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f39dea6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f39dea6', __exports__)) {
    api.reload('5f39dea6', __exports__)
  }
  
  module.hot.accept("./AccessWallet.vue?vue&type=template&id=5f39dea6", () => {
    api.rerender('5f39dea6', render)
  })

}


export default __exports__